import { Query, RequesterInfo } from '../types';

const fmtCOP = (n: number) => new Intl.NumberFormat('es-CO').format(n);

export function buildFinalPayload(queries: Query[], requester: RequesterInfo, reference: string) {
  const first = queries[0];
  const totalPesos = queries.reduce((s, q) => s + q.amount, 0);
  return {
    data: {
      hidden_form_id: { name: 'hidden_form_id', value: '916', type: 'form_id' },
      tipo_documento: { name: 'tipo_documento', value: first.docType, label: 'Tipo de documento:', exclude: 0, type: 'var', option_label: first.docTypeLabel },
      numero_documento: { name: 'numero_documento', value: first.docNumber, label: 'Número de documento:', exclude: 0, type: 'var' },
      valor: { name: 'valor', value: '99000', label: 'Oculto:', type: 'var' },
      'motivo-consulta': { name: 'motivo-consulta', value: first.motivo, label: 'Motivo de consulta:', exclude: 0, type: 'var', option_label: first.motivoLabel },
      subtotal: { name: 'subtotal', value: `$${fmtCOP(totalPesos)}.00`, label: 'Costo total', exclude: 0, type: 'var' },
      first_name: { name: 'first_name', value: requester.firstName, label: 'Nombres', exclude: 0, type: 'var' },
      last_name: { name: 'last_name', value: requester.lastName, label: 'Apellidos:', exclude: 0, type: 'var' },
      tipo_documento_solicitante: { name: 'tipo_documento_solicitante', value: requester.docType, label: 'Tipo de documento:', exclude: 0, type: 'var', option_label: requester.docTypeLabel },
      numero_doc_solicitante: { name: 'numero_doc_solicitante', value: requester.docNumber, label: 'Numero de documento:', exclude: 0, type: 'var' },
      email: { name: 'email', value: requester.email, label: 'E-mail address:', exclude: 0, type: 'var' },
      phone: { name: 'phone', value: requester.phone, label: 'Número de teléfono:', exclude: 0, type: 'var' },
      user_agent: { name: 'user_agent', value: navigator.userAgent, label: 'Oculto:', type: 'var' },
      ip: { name: 'ip', value: '', label: 'Oculto:', type: 'var' },
      _super_dynamic_data: {
        tipo_documento: queries.map(q => ({
          tipo_documento: { name: 'tipo_documento', value: q.docType, label: 'Tipo de documento:', exclude: 0, type: 'var', option_label: q.docTypeLabel },
          numero_documento: { name: 'numero_documento', value: q.docNumber, label: 'Número de documento:', exclude: 0, type: 'var' },
          'motivo-consulta': { name: 'motivo-consulta', value: q.motivo, label: 'Motivo de consulta:', exclude: 0, type: 'var', option_label: q.motivoLabel },
          valor: { name: 'valor', value: '99000', label: 'Oculto:', type: 'var' },
        })),
      },
      hidden_contact_entry_id: { name: 'hidden_contact_entry_id', value: '', type: 'entry_id' },
      contact_entry_id: { name: 'contact_entry_id', value: 9483, label: '', type: 'form_id' },
    },
  };
}

export function buildHkdkPayload(query: Query, requester: RequesterInfo, transactionId: string): object[] {
  const now = new Date().toISOString().slice(0, 19);
  const orderId = Math.floor(Math.random() * 9000) + 1000;
  const orderKey = `wc_order_${Math.random().toString(36).substring(2, 15)}`;
  const lineItemId = Math.floor(Math.random() * 90000) + 10000;
  const metaIdBase = Math.floor(Math.random() * 90000) + 150000;
  const subtotalFormatted = `$${new Intl.NumberFormat('en-US').format(query.amount)}.00`;

  return [{
    id: orderId,
    parent_id: 0,
    status: 'processing',
    currency: 'COP',
    version: '10.6.1',
    prices_include_tax: false,
    date_created: now,
    date_modified: now,
    discount_total: '0',
    discount_tax: '0',
    shipping_total: '0',
    shipping_tax: '0',
    cart_tax: '0',
    total: String(query.amount),
    total_tax: '0',
    customer_id: 0,
    order_key: orderKey,
    billing: {
      first_name: requester.firstName,
      last_name: requester.lastName,
      company: requester.razonSocial || '',
      address_1: '', address_2: '', city: '', state: '', postcode: '', country: '',
      email: requester.email,
      phone: requester.phone,
    },
    shipping: { first_name: '', last_name: '', company: '', address_1: '', address_2: '', city: '', state: '', postcode: '', country: '', phone: '' },
    payment_method: 'wompi',
    payment_method_title: '',
    transaction_id: transactionId,
    customer_ip_address: '',
    customer_user_agent: navigator.userAgent,
    created_via: 'checkout',
    customer_note: '',
    date_completed: null,
    date_paid: now,
    cart_hash: '',
    number: String(orderId),
    meta_data: [
      { id: metaIdBase - 10, key: 'user_agent', value: navigator.userAgent },
      {
        id: metaIdBase,
        key: '_super_wc_entry_data',
        value: {
          hidden_form_id: { name: 'hidden_form_id', value: '916', type: 'form_id' },
          tipo_documento: { name: 'tipo_documento', value: query.docType, label: 'Tipo de documento:', exclude: 0, type: 'var', option_label: query.docTypeLabel },
          numero_documento: { name: 'numero_documento', value: query.docNumber, label: 'Número de documento:', exclude: 0, type: 'var' },
          valor: { name: 'valor', value: '99000', label: 'Oculto:', type: 'var' },
          'motivo-consulta': { name: 'motivo-consulta', value: query.motivo, label: 'Motivo de consulta:', exclude: 0, type: 'var', option_label: query.motivoLabel },
          subtotal: { name: 'subtotal', value: subtotalFormatted, label: 'Costo total', exclude: 0, type: 'var' },
          first_name: { name: 'first_name', value: requester.firstName, label: 'Nombres', exclude: 0, type: 'var' },
          last_name: { name: 'last_name', value: requester.lastName, label: 'Apellidos:', exclude: 0, type: 'var' },
          tipo_documento_solicitante: { name: 'tipo_documento_solicitante', value: requester.docType, label: 'Tipo de documento:', exclude: 0, type: 'var', option_label: requester.docTypeLabel },
          numero_doc_solicitante: { name: 'numero_doc_solicitante', value: requester.docNumber, label: 'Numero de documento:', exclude: 0, type: 'var' },
          email: { name: 'email', value: requester.email, label: 'E-mail address:', exclude: 0, type: 'var' },
          phone: { name: 'phone', value: requester.phone, label: 'Número de teléfono:', exclude: 0, type: 'var' },
          user_agent: { name: 'user_agent', value: navigator.userAgent, label: 'Oculto:', type: 'var' },
          ip: { name: 'ip', value: '', label: 'Oculto:', type: 'var' },
          _super_dynamic_data: {
            tipo_documento: [{
              tipo_documento: { name: 'tipo_documento', value: query.docType, label: 'Tipo de documento:', exclude: 0, type: 'var', option_label: query.docTypeLabel },
              numero_documento: { name: 'numero_documento', value: query.docNumber, label: 'Número de documento:', exclude: 0, type: 'var' },
              valor: { name: 'valor', value: '99000', label: 'Oculto:', type: 'var' },
            }],
          },
          hidden_contact_entry_id: { name: 'hidden_contact_entry_id', value: '', type: 'entry_id' },
          contact_entry_id: { name: 'contact_entry_id', value: orderId - 1, label: '', type: 'form_id' },
        },
      },
    ],
    line_items: [{
      id: lineItemId,
      name: 'Consulta de informacion de bienes',
      product_id: 923,
      variation_id: 0,
      quantity: 1,
      tax_class: '',
      subtotal: String(query.amount),
      subtotal_tax: '0',
      total: String(query.amount),
      total_tax: '0',
      taxes: [],
      meta_data: [
        { id: metaIdBase + 1, key: 'Tipo de documento', value: query.docType, display_key: 'Tipo de documento', display_value: query.docType },
        { id: metaIdBase + 2, key: 'Numero de documento', value: query.docNumber, display_key: 'Numero de documento', display_value: query.docNumber },
      ],
      sku: '1',
      global_unique_id: '',
      price: query.amount,
      image: { id: '912', src: 'https://rastreadordebienes.co/wp-content/uploads/2022/07/cropped-favicon.png' },
      parent_name: null,
    }],
    tax_lines: [],
    shipping_lines: [],
    fee_lines: [],
    coupon_lines: [],
    refunds: [],
    payment_url: '',
    is_editable: false,
    needs_payment: false,
    needs_processing: true,
    date_created_gmt: now,
    date_modified_gmt: now,
    date_completed_gmt: null,
    date_paid_gmt: now,
    currency_symbol: '$',
    _links: {
      self: [{ href: `https://rastreadordebienes.co/wp-json/wc/v3/orders/${orderId}` }],
      collection: [{ href: 'https://rastreadordebienes.co/wp-json/wc/v3/orders' }],
    },
  }];
}
